"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRadiologyProcedureSchema = exports.createRadiologyProcedureSchema = exports.radiologyProcedureShape = void 0;
const zod_1 = require("zod");
exports.radiologyProcedureShape = {
    procedureCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    modalityId: zod_1.z.string().uuid().optional(),
    bodyPartId: zod_1.z.string().uuid().optional(),
    requiresContrast: zod_1.z.boolean().default(false),
    /** ECM — the `ChargeMaster` this procedure bills as. Present in the schema since Phase 4, but until now unreachable through the API because it was missing here. */
    chargeId: zod_1.z.string().uuid().nullish(),
};
exports.createRadiologyProcedureSchema = zod_1.z.object(exports.radiologyProcedureShape);
exports.updateRadiologyProcedureSchema = exports.createRadiologyProcedureSchema.partial();
//# sourceMappingURL=radiology-procedure.schema.js.map